<div class="fm-map-container"
  [class.fm-map-container--narrow]="(isMobileOrTablet$ | async) === false && (isReplayOpen$ | async)"
  [@overlaySidePanelOpen]="isSidePanelOpen$ | async">
  <ng-content></ng-content>
</div>